import {TBaseModel, TListBaseModel} from './common/t-base.model';
import {AutoMap} from '@automapper/classes';
import {FormField} from '../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';
import {INTERNAL_API_KEY_CONSTANTS} from '../../core/constants/internal-api-key.constants';

export class HighlightListModel extends TListBaseModel {
  @AutoMap()
  public sourceId!: string;

  @AutoMap()
  public sourceName!: string;

  @AutoMap()
  public text: string = '';

  @AutoMap()
  public isStarred: boolean = false;
}

export class HighlightModel extends TBaseModel {
  @FormField({
    hidden: true
  })
  @AutoMap()
  public sourceId!: string;

  @FormField({
    type: 'lookup',
    previewName: 'source',
    internalApiKey: INTERNAL_API_KEY_CONSTANTS.HIGHLIGHT_SOURCE_LOOKUP,
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  public sourceName!: string;

  @FormField({
    type: 'textarea',
    default: '',
    validators: [Validators.required]
  })
  @AutoMap()
  public text: string = '';

  @FormField({
    type: 'textarea',
    default: '',
    validators: []
  })
  @AutoMap()
  public description: string | null = null;

  // TODO: uncomment and implement priority field later
  // @FormField({
  //   default: '',
  //   validators: []
  // })
  // @AutoMap()
  // public priority!: string;

  @FormField({
    previewName: 'quoted By',
    default: '',
    validators: []
  })
  @AutoMap()
  public quotedBy: string | null = null;

  @FormField({
    type: 'toggle',
    previewName: 'Favorite',
    default: false,
    validators: []
  })
  @AutoMap()
  public isStarred: boolean = false;
}
